import React from "react";
import { Inbox } from "lucide-react";

export function EmptyState({ title, text, action, testId }: { title: string; text?: string; action?: React.ReactNode; testId?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-slate-300 bg-white px-6 py-14 text-center" data-testid={testId || "empty-state"}>
      <div className="grid h-12 w-12 place-items-center rounded-xl bg-signal-soft text-signal"><Inbox className="h-6 w-6" /></div>
      <p className="font-display text-lg font-bold text-ink">{title}</p>
      {text && <p className="max-w-sm text-sm text-slate-500">{text}</p>}
      {action}
    </div>
  );
}
